<template>
  <div class="shelf-page">
    <form class="pure-form">
      <input
        v-if="!embed"
        type="text"
        v-model="filter"
        placeholder="Search books"
      />
    </form>
    <shelf :shelf="shelf" :user="user" :filter="filter.trim()" />
  </div>
</template>
<script>
import Shelf from '../components/Shelf';

export default {
  name: 'shelfPage',
  components: {
    shelf: Shelf,
  },

  data() {
    return {
      filter: '',
      shelf: {
        label: this.$route.params.shelflabel,
      },
      token: this.$cookies.get('user'),
      user: {
        username: this.$route.params.username,
      },
      embed:
        !(typeof this.$route.query.embed === 'undefined')
        && this.$route.query.embed !== 'false',
    };
  },
};
</script>
